import { render } from "./NormolipidicDiagnosis.vue?vue&type=template&id=01e0ada5"
import script from "./NormolipidicDiagnosis.vue?vue&type=script&lang=js"
export * from "./NormolipidicDiagnosis.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__